export default "__VITE_ASSET__nh0gefDp__"